<template>    
    <PageFull header="Адм. банки" type="white" :fullwidth="true" :nopadding="true">
        <template v-slot:body>
            <div class="flex flex-column w-full">
                <BankList />
            </div>
        </template>
    </PageFull>
</template>

<script>
import BankList from '@/components/admin/BankList.vue'
import PageFull from '@/components/sides/PageFull.vue'

export default {
    data() {
        return {
            
        }
    },
    components: {
        BankList,
        PageFull  
    },
}
</script>